import './src/styles/global.css'
// shared-components dist inlines CSS into JS (rollup postcss). Import the
// source files here so Gatsby extracts them into the HTML stylesheet and
// Layout chrome is styled before JS runs.
import '../../packages/shared-components/src/components/Navbar/Navbar.css'
import '../../packages/shared-components/src/components/Navbar/NavbarMobile/NavbarMobile.css'
import '../../packages/shared-components/src/components/Navbar/NavItem/NavItem.css'
import '../../packages/shared-components/src/components/Dropdown/Dropdown.css'
import '../../packages/shared-components/src/components/Banner/Banner.css'
import '../../packages/shared-components/src/components/Footer/Footer.css'
import '../../packages/shared-components/src/components/Button/Button.css'
import React from 'react'
import type {
  ShouldUpdateScrollArgs,
  WrapPageElementBrowserArgs,
  WrapRootElementBrowserArgs,
} from 'gatsby'
import Layout from './src/components/Layout/Layout'
import ApolloClientSoftwareCloud from './src/providers/ApolloProvider/ApolloClientSoftwareCloud'
import AuthProvider from './src/providers/AuthProvider/AuthProvider'
import ScriptProvider from './src/providers/ScriptProvider/ScriptProvider'
import AppContextProvider from './src/providers/AppContext/AppContext'

const wrapRootElement = ({ element }: WrapRootElementBrowserArgs) => {
  return (
    <AuthProvider>
      <ApolloClientSoftwareCloud>
        <AppContextProvider>{element}</AppContextProvider>
      </ApolloClientSoftwareCloud>
    </AuthProvider>
  )
}

const wrapPageElement = ({ element, props }: WrapPageElementBrowserArgs) => {
  return (
    <ScriptProvider>
      <Layout {...props}>{element}</Layout>
    </ScriptProvider>
  )
}

const shouldUpdateScroll = ({
  routerProps: { location },
}: ShouldUpdateScrollArgs) => {
  const hasHash = location.hash !== ''
  if (typeof window !== 'undefined' && !hasHash)
    window.scroll({
      top: 0,
      left: 0,
      behavior: 'instant',
    })
  return true
}

// Export browser configurations
export { wrapRootElement, wrapPageElement, shouldUpdateScroll }
